import { render } from "./Department-details.vue?vue&type=template&id=0b2d8e86&scoped=true"
import script from "./Department-details.vue?vue&type=script&lang=js"
export * from "./Department-details.vue?vue&type=script&lang=js"

import "./Department-details.vue?vue&type=style&index=0&id=0b2d8e86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b2d8e86"

export default script